import React, { useEffect, useRef, useState } from 'react';
import browserIcon from './assets/quest-browser.svg';
import profilePhoto from '../../Home/assets/profile.jpeg';
import './QuestDock.css';

const socialApps = [
  { id: 'instagram', label: 'Instagram', href: 'https://www.instagram.com/jliu_99',
    path: 'M8 0C5.827 0 5.555.01 4.702.048 3.85.088 3.27.222 2.76.42c-.526.204-.973.478-1.417.923-.445.444-.72.89-.923 1.417-.198.51-.333 1.09-.372 1.942C.008 5.555 0 5.827 0 8s.01 2.445.048 3.298c.04.852.174 1.433.372 1.942.204.526.478.973.923 1.417.444.445.89.72 1.417.923.51.198 1.09.333 1.942.372.853.04 1.125.048 3.298.048s2.445-.01 3.298-.048c.852-.04 1.433-.174 1.942-.372.526-.204.973-.478 1.417-.923.445-.444.72-.89.923-1.417.198-.51.333-1.09.372-1.942.04-.853.048-1.125.048-3.298s-.01-2.445-.048-3.298c-.04-.852-.174-1.433-.372-1.942-.204-.526-.478-.973-.923-1.417-.444-.445-.89-.72-1.417-.923-.51-.198-1.09-.333-1.942-.372C10.445.008 10.173 0 8 0zm0 1.44c2.136 0 2.39.01 3.233.048.78.036 1.203.166 1.485.276.374.145.64.318.92.598.28.28.453.546.598.92.11.282.24.705.276 1.485.038.844.047 1.097.047 3.233s-.01 2.39-.048 3.233c-.036.78-.166 1.203-.276 1.485-.145.374-.318.64-.598.92-.28.28-.546.453-.92.598-.282.11-.705.24-1.485.276-.844.038-1.097.047-3.233.047s-2.39-.01-3.233-.048c-.78-.036-1.203-.166-1.485-.276-.374-.145-.64-.318-.92-.598-.28-.28-.453-.546-.598-.92-.11-.282-.24-.705-.276-1.485C1.45 10.39 1.44 10.136 1.44 8s.01-2.39.048-3.233c.036-.78.166-1.203.276-1.485.145-.374.318-.64.598-.92.28-.28.546-.453.92-.598.282-.11.705-.24 1.485-.276C5.61 1.45 5.864 1.44 8 1.44zm0 2.452c-2.27 0-4.108 1.84-4.108 4.108 0 2.27 1.84 4.108 4.108 4.108 2.27 0 4.108-1.84 4.108-4.108 0-2.27-1.84-4.108-4.108-4.108zm0 6.775c-1.473 0-2.667-1.194-2.667-2.667 0-1.473 1.194-2.667 2.667-2.667 1.473 0 2.667 1.194 2.667 2.667 0 1.473-1.194 2.667-2.667 2.667zm5.23-6.937c0 .53-.43.96-.96.96s-.96-.43-.96-.96.43-.96.96-.96.96.43.96.96z' },
  { id: 'github', label: 'GitHub', href: 'https://github.com/jerryliu0',
    path: 'M8 0C3.58 0 0 3.582 0 8c0 3.535 2.292 6.533 5.47 7.59.4.075.547-.172.547-.385 0-.19-.007-.693-.01-1.36-2.226.483-2.695-1.073-2.695-1.073-.364-.924-.89-1.17-.89-1.17-.725-.496.056-.486.056-.486.803.056 1.225.824 1.225.824.714 1.223 1.873.87 2.33.665.072-.517.278-.87.507-1.07-1.777-.2-3.644-.888-3.644-3.953 0-.873.31-1.587.823-2.147-.083-.202-.358-1.015.077-2.117 0 0 .672-.215 2.2.82.638-.178 1.323-.266 2.003-.27.68.004 1.364.092 2.003.27 1.527-1.035 2.198-.82 2.198-.82.437 1.102.163 1.915.08 2.117.513.56.823 1.274.823 2.147 0 3.073-1.87 3.75-3.653 3.947.287.246.543.735.543 1.48 0 1.07-.01 1.933-.01 2.195 0 .215.144.463.55.385C13.71 14.53 16 11.534 16 8c0-4.418-3.582-8-8-8' },
  { id: 'linkedin', label: 'LinkedIn', href: 'https://www.linkedin.com/in/je66yliu/',
    path: 'M13.632 13.635h-2.37V9.922c0-.886-.018-2.025-1.234-2.025-1.235 0-1.424.964-1.424 1.96v3.778h-2.37V6H8.51V7.04h.03c.318-.6 1.092-1.233 2.247-1.233 2.4 0 2.845 1.58 2.845 3.637v4.188zM3.558 4.955c-.762 0-1.376-.617-1.376-1.377 0-.758.614-1.375 1.376-1.375.76 0 1.376.617 1.376 1.375 0 .76-.617 1.377-1.376 1.377zm1.188 8.68H2.37V6h2.376v7.635zM14.816 0H1.18C.528 0 0 .516 0 1.153v13.694C0 15.484.528 16 1.18 16h13.635c.652 0 1.185-.516 1.185-1.153V1.153C16 .516 15.467 0 14.815 0z' },
];

const formatTime = () => new Intl.DateTimeFormat(undefined, { hour: 'numeric', minute: '2-digit' }).format(new Date());

export default function QuestDock({
  browserVisible = true,
  onToggleBrowser,
  showMotionToggle = false,
  motionEnabled = false,
  motionPending = false,
  onToggleMotion,
}) {
  const [time, setTime] = useState(formatTime);
  const [touchInput, setTouchInput] = useState(false);
  const [touchFeedback, setTouchFeedback] = useState(null);
  const touch = useRef({ pointerId: null, timer: null });
  const browserLabel = browserVisible ? 'Minimize browser' : 'Restore browser';
  const motionLabel = motionEnabled ? 'Disable motion' : 'Enable motion';

  useEffect(() => {
    const currentTouch = touch.current;
    const clearFeedback = () => {
      window.clearTimeout(currentTouch.timer);
      currentTouch.pointerId = null;
      setTouchFeedback(null);
    };
    const releaseTouch = (event) => {
      if (currentTouch.pointerId === null || event.pointerId !== currentTouch.pointerId) return;
      currentTouch.pointerId = null;
      setTouchFeedback((feedback) => feedback && { ...feedback, pressed: false });
      currentTouch.timer = window.setTimeout(() => setTouchFeedback(null), 1000);
    };
    const cancelTouch = (event) => {
      if (currentTouch.pointerId !== null && event.pointerId === currentTouch.pointerId) clearFeedback();
    };
    const visibilityChange = () => {
      if (document.hidden) clearFeedback();
    };
    // Observe releases outside the dock without capturing or replacing native taps.
    document.addEventListener('pointerup', releaseTouch, true);
    document.addEventListener('pointercancel', cancelTouch, true);
    document.addEventListener('lostpointercapture', cancelTouch, true);
    window.addEventListener('blur', clearFeedback);
    document.addEventListener('visibilitychange', visibilityChange);
    return () => {
      window.clearTimeout(currentTouch.timer);
      document.removeEventListener('pointerup', releaseTouch, true);
      document.removeEventListener('pointercancel', cancelTouch, true);
      document.removeEventListener('lostpointercapture', cancelTouch, true);
      window.removeEventListener('blur', clearFeedback);
      document.removeEventListener('visibilitychange', visibilityChange);
    };
  }, []);

  const pointerDown = (event) => {
    if (event.pointerType === 'mouse') setTouchInput(false);
    if (event.pointerType !== 'touch') return;
    setTouchInput(true);
    const control = event.target.closest('[data-quest-action]');
    if (!control || control.disabled || touch.current.pointerId !== null) return;
    window.clearTimeout(touch.current.timer);
    touch.current.pointerId = event.pointerId;
    setTouchFeedback({ action: control.dataset.questAction, pressed: true });
  };
  const touchProps = (action) => ({
    'data-touch-pressed': (touchFeedback?.action === action && touchFeedback.pressed) || undefined,
    'data-touch-tooltip': touchFeedback?.action === action || undefined,
  });

  useEffect(() => {
    let clockTimer;
    const updateTime = () => {
      window.clearTimeout(clockTimer);
      setTime(formatTime());
      // Follow wall-clock minutes instead of counting from when the page opened.
      clockTimer = window.setTimeout(updateTime, 60000 - (Date.now() % 60000));
    };
    updateTime();
    window.addEventListener('focus', updateTime);
    document.addEventListener('visibilitychange', updateTime);
    return () => {
      window.clearTimeout(clockTimer);
      window.removeEventListener('focus', updateTime);
      document.removeEventListener('visibilitychange', updateTime);
    };
  }, []);

  return (
    <div
      className="quest-dock"
      role="toolbar"
      aria-label="Spatial taskbar"
      data-touch-input={touchInput || undefined}
      onPointerDown={pointerDown}
      onPointerMove={(event) => { if (event.pointerType === 'mouse') setTouchInput(false); }}
    >
      <div className="quest-dock-status">
        <a
          className="quest-dock-profile"
          data-quest-action="email"
          {...touchProps('email')}
          aria-label="Email Jerry"
          href="mailto:jerrliu99@gmail.com"
        >
          <img className="quest-dock-avatar" src={profilePhoto} alt="" draggable="false" />
          <span className="quest-dock-online" aria-hidden="true" />
        </a>

        <div className="quest-dock-system" aria-label={`Local time ${time}`}>
          <span className="quest-dock-time">{time}</span>
          <div className="quest-dock-indicators" aria-hidden="true">
            <svg className="quest-dock-wifi" viewBox="0 0 18 14" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round">
              <path d="M2 4a11 11 0 0 1 14 0M5 7a6.5 6.5 0 0 1 8 0M8 10a2 2 0 0 1 2 0" />
              <circle cx="9" cy="12" r=".7" fill="currentColor" stroke="none" />
            </svg>
            <svg className="quest-dock-battery" viewBox="0 0 24 14" fill="none" stroke="currentColor" strokeWidth="1.3">
              <rect x="1" y="2" width="19" height="10" rx="2.5" />
              <path d="M22 5v4" strokeLinecap="round" />
              <rect x="3.5" y="4.5" width="13" height="5" rx=".8" fill="currentColor" stroke="none" />
            </svg>
          </div>
        </div>
      </div>

      <div className="quest-dock-apps">
        {showMotionToggle && (
          <button
            type="button"
            className={`quest-dock-app quest-dock-app-motion${motionEnabled ? ' is-selected' : ''}`}
            data-quest-action="motion"
            {...touchProps('motion')}
            aria-label={motionLabel}
            aria-pressed={motionEnabled}
            aria-busy={motionPending}
            disabled={motionPending}
            onClick={onToggleMotion}
          >
            <span className="quest-dock-app-icon">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <rect x="7.5" y="3" width="9" height="18" rx="2" />
                <path d="M11 17.5h2M4.5 8a8 8 0 0 0 0 8M19.5 8a8 8 0 0 1 0 8M2 10a5 5 0 0 0 0 4M22 10a5 5 0 0 1 0 4" />
              </svg>
            </span>
            <span className="quest-dock-tooltip" aria-hidden="true">Motion</span>
            {motionEnabled && <span className="quest-dock-active-dot" aria-hidden="true" />}
          </button>
        )}
        <button
          type="button"
          className={`quest-dock-app quest-dock-app-browser${browserVisible ? ' is-selected' : ''}`}
          data-quest-action="browser"
          {...touchProps('browser')}
          aria-label={browserLabel}
          aria-pressed={browserVisible}
          onClick={onToggleBrowser}
        >
          <span className="quest-dock-app-icon"><img src={browserIcon} alt="" draggable="false" /></span>
          <span className="quest-dock-tooltip" aria-hidden="true">Browser</span>
          {browserVisible && <span className="quest-dock-active-dot" aria-hidden="true" />}
        </button>
        {socialApps.map((app) => (
          <a
            key={app.id}
            className={`quest-dock-app quest-dock-app-${app.id}`}
            data-quest-action={app.id}
            {...touchProps(app.id)}
            aria-label={app.label}
            href={app.href}
            target="_blank"
            rel="noopener noreferrer"
          >
            <span className="quest-dock-app-icon">
              <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true"><path d={app.path} /></svg>
            </span>
            <span className="quest-dock-tooltip" aria-hidden="true">{app.label}</span>
          </a>
        ))}
      </div>
    </div>
  );
}
